var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReminder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6001 1.33331L14.6668 3.90665L13.8068 4.92665L10.7401 2.35331L11.6001 1.33331ZM4.40004 1.33331L5.25337 2.35331L2.19337 4.91998L1.33337 3.89998L4.40004 1.33331ZM2.00004 8.75998C2.00004 5.44665 4.68671 2.75998 8.00004 2.75998C11.3134 2.75998 14 5.44665 14 8.75998C14 12.0733 11.3134 14.76 8.00004 14.76C4.68004 14.76 2.00004 12.0733 2.00004 8.75998ZM7.33337 5.42665H8.33337V8.92665L11 10.5066L10.5 11.3266L7.33337 9.42665V5.42665Z",
    fill: "#4E5A71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminder);
export default __webpack_public_path__ + "static/media/Reminder.6e62f92b6ff055085723a6dba5e56e6b.svg";
export { ForwardRef as ReactComponent };